import { AssetManagementRepository } from '../data/asset-management-repository';
import { AssetListParams, AssetListResponse } from '../types/asset-types';

/**
 * Use case for fetching paginated list of assets
 */
export class GetAssetsUseCase {
  constructor(private readonly repository: AssetManagementRepository) {}

  async execute(params: AssetListParams): Promise<AssetListResponse> {
    return this.repository.getAssets(params);
  }
}
